import {
  Box,
  Text,
  ThemeColors,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  width: 100%;
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  gap: ${({ theme }) => getThemeSpacing(3, theme)};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  flex-direction: column;
  height: 100%;
`

export const ColoredBox = styled(Box)<{ color: ThemeColors }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${({ color, theme }) => getThemeColor(color, theme)};
`

export const LabelText = styled(Text)`
  & p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`

export const Labels = styled(Box)`
  display: grid;
  width: 100%;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));

  @media (min-width: 1650px) {
    grid-template-columns: repeat(3, minmax(150px, 1fr));
  }
`
